// extracted by mini-css-extract-plugin
export default {"badge":"BadgeCor_badge__UMCwH","end":"BadgeCor_end__dDx3G","noStart":"BadgeCor_noStart__P+8Pr"};